

































import { Vue, Component } from "vue-property-decorator";

import IconCart from "@/components/icons/IconCart.vue";

import { cartModule, pricesModule } from "@/plugins/store-accessors";

@Component({
  components: {
    IconCart,
  },
})
export default class CartButton extends Vue {
  get getCartSum() {
    return cartModule.getCartSum;
  }

  get getCartQuantity() {
    return cartModule.getCartQuantity;
  }

  get hidePrice() {
    return pricesModule.getHidePrice;
  }

  openCart() {
    if (this.$route.path !== "/cart") this.$router.push("/cart");
  }
}
